import axiosInstance from "../api/axiosInstance";

// GET list with pagination and search
export const fetchCategories = (params) => axiosInstance.get("/admin/categoryList", { params });

// ADD
export const addCategory = (data) => axiosInstance.post("/admin/categoryAdd", data);

// UPDATE
export const updateCategory = (id, data) => axiosInstance.put(`/admin/categoryUpdate/${id}`, data);

// CHANGE STATUS
export const changeCategoryStatus = (id, data) => axiosInstance.patch(`/admin/categoryChangeStatus/${id}`, data);

// DELETE
export const deleteCategory = (id) => axiosInstance.delete(`/admin/categoryDelete/${id}`);

// BULK DELETE
export const bulkDeleteCategories = (ids) => axiosInstance.post("/admin/categoryBulkDelete", { ids });

// Get By ID
export const getCategoryById = (id) => axiosInstance.get(`/admin/categoryGet/${id}`);
